import React, { ReactNode } from 'react';
import { MonkVisitsProvider } from '../contexts/MonkVisitsContext';
import { MaintenanceTasksProvider } from '../contexts/MaintenanceTasksContext';
import { VasTeamsProvider } from '../contexts/VasTeamsContext';
import { VasBudgetProvider } from '../contexts/VasBudgetContext';

/**
 * Wraps the admin route only. These providers all fetch from Firestore on
 * mount (see AppProviders.tsx for why they moved out of the global tree) and
 * are only consumed by src/components/admin/* — nothing outside the admin
 * surface reads their context. DonationsProvider is NOT here: App.tsx mounts
 * it one level up, shared with the offerings route, so navigating between
 * offerings and admin doesn't unmount/remount it and refetch donation data.
 */
export const AdminProviders: React.FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <MonkVisitsProvider>
            <MaintenanceTasksProvider>
                <VasTeamsProvider>
                    <VasBudgetProvider>
                        {children}
                    </VasBudgetProvider>
                </VasTeamsProvider>
            </MaintenanceTasksProvider>
        </MonkVisitsProvider>
    );
};
